import * as Yup from 'yup'

const formatMoney = value => Number (value).toLocaleString ('pt-BR', {
  style: 'currency',
  currency: 'BRL'
})

/*
  `availableBalance` e `minValue` existem no formulário apenas como referência das regras
  abaixo — o teto é o que o titular pode gastar agora e o piso é o valor mínimo de saque
  informado pela API. Nenhum dos dois é enviado no POST.

  O saldo é reconferido pela API antes de debitar: aqui a checagem só evita mandar o
  titular até a confirmação para receber um erro que já era previsível.
*/
const bankingWithdrawValidator = Yup.object ().shape ({
  availableBalance: Yup.number ().default (0),
  minValue: Yup.number ().default (0),

  value: Yup.number ()
    .typeError ('Insira o valor do saque')
    .positive ('Insira o valor do saque')
    .min (
      Yup.ref ('minValue'),
      ({ min }) => `O valor mínimo para saque é de ${formatMoney (min)}`
    )
    .max (Yup.ref ('availableBalance'), 'O valor é maior que o seu saldo disponível')
    .required ('Insira o valor do saque')
})

export default bankingWithdrawValidator
